const chatConstants = {
  data: {
      labels: [],
      datasets: [
          {
              label: 'Number of clients',
              maxBarThickness: 40,
              data: [],
              backgroundColor: [
                  '#3868A5',
                  '#3868A5',
                  '#3868A5',
                  '#3868A5',
                  '#3868A5',
                  '#3868A5',
              ],
              borderColor: [
                  '#3868A5',
                  '#3868A5',
                  '#3868A5',
                  '#3868A5',
                  '#3868A5',
                  '#3868A5',
              ],
              borderWidth: 1,
          },
      ],
  },

  unitAndLocationData: {
      labels: [],
      datasets: [
          {
              label: 'Number of clients',
              maxBarThickness: 40,
              data: [],
              backgroundColor: [
                  '#3868A5',
                  '#3868A5',
                  '#3868A5',
                  '#3868A5',
                  '#3868A5',
                  '#3868A5',
              ],
              borderColor: [
                  '#3868A5',
                  '#3868A5',
                  '#3868A5',
                  '#3868A5',
                  '#3868A5',
                  '#3868A5',
              ],
              borderWidth: 1,
          },
      ],
  },

  statusChartData: {
      labels: [],
      datasets: [
          {
              label: 'Number of clients',
              maxBarThickness: 40,
              data: [],
              backgroundColor: [
                  '#40bac6',
                  '#40bac6',
                  '#40bac6',
                  '#40bac6',
                  '#40bac6',
                  '#40bac6',
              ],
              borderColor: [
                  '#40bac6',
                  '#40bac6',
                  '#40bac6',
                  '#40bac6',
                  '#40bac6',
                  '#40bac6',
              ],
              borderWidth: 1,
          },
      ],
  },
  leadershipData: {
      labels: [],
      datasets: [
          {
              label: 'Number of clients',
              maxBarThickness: 40,
              data: [],
              backgroundColor: [
                  '#F37970',
                  '#F37970',
                  '#F37970',
                  '#F37970',
                  '#F37970',
                  '#F37970',
              ],
              borderColor: [
                  '#F37970',
                  '#F37970',
                  '#F37970',
                  '#F37970',
                  '#F37970',
                  '#F37970',
              ],
              borderWidth: 1,
          },
      ],
  },
  businessUnitData: {
      labels: [],
      datasets: [
          {
              label: 'Number of clients',
              maxBarThickness: 40,
              data: [],
              backgroundColor: [
                  '#078f47',
                  '#078f47',
                  '#078f47',
                  '#078f47',
                  '#078f47',
                  '#078f47',
              ],
              borderColor: [
                  '#078f47',
                  '#078f47',
                  '#078f47',
                  '#078f47',
                  '#078f47',
                  '#078f47',
              ],
              borderWidth: 1,
          },
      ],
  },

  perMonthData: {
      labels: [],
      datasets: [
          {
              label: 'Number of clients',
              maxBarThickness: 40,
              data: [],
              backgroundColor: [
                  '#40bac6',
                  '#40bac6',
                  '#40bac6',
                  '#40bac6',
                  '#40bac6',
                  '#40bac6',
              ],
              borderColor: [
                  '#40bac6',
                  '#40bac6',
                  '#40bac6',
                  '#40bac6',
                  '#40bac6',
                  '#40bac6',
              ],
              borderWidth: 1,
          },
      ],
  },

  options: {
      plugins: {
          legend: {
              align: 'center',
              labels: {
                  boxWidth: 25,
                  padding: 15,
              }
          }
      },
      scales: {
          y: {
            // max:60,
            ticks:{
                stepSize:1,
            },
            grace:"50%",
          }
          }
      },

  slaPieGraph: {
      labels: ['Red', 'Blue', 'Yellow', 'Green', 'Purple', 'Orange'],
      datasets: [
          {
              label: '# of Votes',
              data: [12, 19, 3, 5, 2, 3],
              backgroundColor: [
                  'rgba(255, 99, 132, 0.2)',
                  'rgba(54, 162, 235, 0.2)',
                  'rgba(255, 206, 86, 0.2)',
                  'rgba(75, 192, 192, 0.2)',
                  'rgba(153, 102, 255, 0.2)',
                  'rgba(255, 159, 64, 0.2)',
              ],
              borderColor: [
                  'rgba(255, 99, 132, 1)',
                  'rgba(54, 162, 235, 1)',
                  'rgba(255, 206, 86, 1)',
                  'rgba(75, 192, 192, 1)',
                  'rgba(153, 102, 255, 1)',
                  'rgba(255, 159, 64, 1)',
              ],
              borderWidth: 1,
          },
      ],

  },

  horizontaloptions: {
      indexAxis: 'y',
      // Elements options apply to all of the options unless overridden in a dataset
      // In this case, we are setting the border of each horizontal bar to be 2px wide
      elements: {
          bar: {
              borderWidth: 2,
          },
      },
      responsive: true,
      plugins: {
          legend: {
              align: "center",
              labels: {
                  boxWidth: 25,
                  padding: 15,
              }
          },
          title: {
              display: true,
              text: '',
          },
      },
      scales: {
          x: {
            //   max: 8,
              min: 0,
              grace:"50%",
              ticks: {
            stepSize: 1,
              }
          }
      }
  },

  linedata: {
      labels: ['1', '2', '3', '4', '5', '6'],
      datasets: [
          {
              label: 'Average duration',
              data: [12, 19, 3, 5, 2, 3],
              backgroundColor: "##a3a110",
              borderColor: '#a3a110'
          },
          // {
          //     label: 'Average duration',
          //     data: [12, 97, 33, 52, 2, 23],
          //     backgroundColor: "black",
          //     borderColor: 'rgba(255, 99, 132, 0.2)'
          // },
          // {
          //     label: 'Average duration',
          //     data: [12, 139, 3, 35, 2, 31],
          //     backgroundColor: "red",
          //     borderColor: 'rgba(255, 99, 132, 0.2)'
          // },

      ],
  },

  finLinedata: {
      labels: ['1', '2', '3', '4', '5', '6'],
      datasets: [
          {
              label: 'Average duration',
              data: [12, 19, 3, 5, 2, 3],
              backgroundColor: "#3B86FF",
              borderColor: "#3B86FF",
          },
          {
              label: 'Average duration',
              data: [12, 97, 33, 52, 2, 23],
              backgroundColor: "black",
              borderColor: "#595959"
          },
        //   {
        //       label: 'Average duration',
        //       data: [12, 139, 3, 35, 2, 31],
        //       backgroundColor: "red",
        //       borderColor: "#ff7070"
        //   },

      ],
  },
  lineOption: {
      responsive: true,
      plugins: {
          legend: {
              position: 'top',
              labels: {
                  boxWidth: 25,
                  padding: 15,
              }
          },
      },
      scales:{
        y:{
            grace:"50%",
        }
      }
  },

  stackdata: {
      labels: ['1', '2', '3', '4', '5', '6'],
      datasets: [
          {
              label: '# of Red Votes',
              data: [12, 19, 3, 5, 2, 3],
              backgroundColor: '#07438f',
          },
          {
              label: '# of Blue Votes',
              data: [2, 3, 20, 5, 1, 4],
              backgroundColor: '#078f47',
          },
          {
              label: '# of Green Votes',
              data: [3, 10, 13, 15, 22, 30],
              backgroundColor: '#a3a110',
          },
      ],

  },

  stackoptions: {
      indexAxis: 'y',
      scales: {
          x: {
              stacked: true,
              ticks: {
                  beginAtZero: true
              }
          },
          y: {
              stacked: true
          }
      },
      elements: {
          bar: {
              borderWidth: 2,
          },
      },
      responsive: true,
      plugins: {
          legend: {
              position: 'right',
              labels: {
                  boxWidth: 25,
                  padding: 15,
              }
          },
          title: {
              display: true,
              text: '',
          },
      },
  }
}

export default chatConstants
